import { z } from 'zod';

export const recordDeviceMatchV2BodySchema = z.object({
  deviceId: z.string().min(1).max(128),
  fingerprint: z.string().min(1).max(512),
});

export type IRecordDeviceMatchV2Body = z.infer<typeof recordDeviceMatchV2BodySchema>;
